// extracted by mini-css-extract-plugin
export default {"pageLayout":"MatchScoresStats-module__pageLayout___MFyqd"};